import {Loader as LoaderComponent, SplashLoader} from "./Loader";

export const Loader = Object.assign(LoaderComponent, {
    Splash: SplashLoader
});